import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output} from '@angular/core';
import {SemRestRequestService} from '../../../../../../projects/api/src/sem-rest-request/sem-rest-request.service';
import {ApiList} from '../../../../API/api-list.enum';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {IsAuthorizedService} from '../../../services/is-authorized.service';
import {FavoritesApiService, IFavoriteObject} from '../../../../../../projects/api/src/favorite/favorites-api.service';
import {FavoriteModel, FavoriteType} from '../../../../../../projects/api/src/favorite/favorite.model';
import {TranslateService} from '@ngx-translate/core';

/**
 * Компонент служит для отображения иконки "звезда"
 * Важно: при переходе в дашбордах не отрабатывают события роутера, поэтому
 * используется кэширование ссылок и принудительная проверка на изменение урла каждые 1000мс
 */
@Component({
    selector: 'app-favorite-dialog',
    templateUrl: './favorite-dialog.component.html',
    styleUrls: ['./favorite-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FavoriteDialogComponent implements OnInit {
  public favLinkForm: FormGroup;
  public selected = false;
  public linkId = -1;
  private favLinksCache: FavoriteModel[] = [];
  private intervalId;

  @Input() id: number;

  @Output() showChange = new EventEmitter<boolean>();
  @Output() close = new EventEmitter();

  model: FavoriteModel;

  favorite: IFavoriteObject;

  url: string;

  FavoriteType = FavoriteType;

  isLoading = true;

  mode;
  modes = [];

  constructor(
    private request: SemRestRequestService,
    private fb: FormBuilder,
    private ref: ChangeDetectorRef,
    private router: Router,
    private zone: NgZone,
    private isAuthorizedService: IsAuthorizedService,
    private favoritesApiService: FavoritesApiService,
    private ngxTranslateService: TranslateService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) {
    this.route.url.subscribe((val) => {
      this.favoritesApiService.setFavoriteObject();
    });
  }

  ngOnInit() {
    this.createForm();
    this.isFavLinkInLocation();
    this.router.events.subscribe((r) => {
      if (r instanceof NavigationEnd) {
        this.isFavLinkInLocation();
      }
    });
    // Нужно так как роутер в AngularJS не всегда отдает обновление URL, чтобы не нагружать CD выносим за зону
    this.zone.runOutsideAngular(() => this.intervalId = setInterval(() => this.isFavLinkInLocation(true), 2000));

    if (this.id) {
      console.log('this.id', this.id);
      this.favoritesApiService.get(this.id).subscribe((data) => {
        this.model = data;
        this.favorite = {title: data.description, type: data.linktype, id: `${data.linkobjid}`};
        this.url = data.url;
        this.favLinkForm.reset({description: this.favorite.title});
        this.updateButtons();
      });
    } else {

      this.favoritesApiService.favorite.subscribe((val) => {
        this.favorite = val;
        this.url = document.location.href;
        this.favLinkForm.reset({description: this.favorite.title});
        this.updateButtons();
      });

    }
  }

  updateButtons() {
    this.modes = [];
    this.mode = FavoriteType.URL;
    if (this.favorite && this.favorite.type !== FavoriteType.URL) {
      this.modes.push({label: 'FavoriteButton.URL', value: FavoriteType.URL});
      this.modes.push({label: `FavoriteButton.${this.favorite.type}`, value: this.favorite.type});
/*
      this.modes.push({label: this.ngxTranslateService.instant('FavoriteButton.URL'), value: FavoriteType.URL});
      this.modes.push({label: this.ngxTranslateService.instant(`FavoriteButton.${this.favorite.type}`), value: this.favorite.type});
*/
      this.mode = this.favorite.type;
    }
    this.isLoading = false;
    this.cdr.detectChanges();
  }

  /**
   * Инициализирует первоначальное состояние формы
   */
  createForm() {
    this.url = document.location.href;
    this.favLinkForm = this.fb.group({
      description: '',
    });
    this.mode = FavoriteType.URL;
  }

  /**
   * Проверяет является ли текущая страница избранной ссылкой
   * @param {boolean} useCache - использовать кэш
   */
  isFavLinkInLocation(useCache: boolean = false) {
    if (!this.isAuthorizedService.isAuthorized.getValue()) {
      clearInterval(this.intervalId);
      return;
    }
    if (useCache) {
      const fl = this.favLinksCache.find((favLink) => favLink.url.toString() === document.location.href.toString());
      if (fl) {
        this.selected = true;
        this.linkId = fl.id;
      } else {
        this.selected = false;
        this.linkId = -1;
      }
      this.ref.markForCheck();
      return;
    }

    if (!this.favorite) {
      return;
    }

    this.favoritesApiService.getAll().subscribe((favLinks) => {
      this.favLinksCache = favLinks;
      const fl = favLinks.find((favLink) => favLink.url.toString() === document.location.href.toString() ||
        (favLink.linktype === this.favorite.type &&
          `${favLink.linkobjid}` === this.favorite.id));
      if (fl) {
        this.selected = true;
        this.linkId = fl.id;
      } else {
        this.selected = false;
        this.linkId = -1;
      }
      this.ref.markForCheck();
    });
  }

  /**
   * Удаляет текущую страницу из списка избранного
   */
  deleteFavLink() {
    if (this.linkId > 0) {
      this.favLinksCache = [];
      this.request
        .baseUrlAppend(ApiList.Db, ApiList.User, ApiList.Profile, ApiList.Favorites)
        .deleteById(this.linkId)
        .subscribe(() => {
          this.isFavLinkInLocation();
        });
    }
  }

  /**
   * Показывает диалог для добавления текущей страницы в избранное
   */
  showEditDialog() {
    this.ref.markForCheck();
  }

  /**
   * Скрывает диалог по добавлению страницы
   */
  hideEditDialog() {
    this.isFavLinkInLocation();
    this.close.emit();
  }

  onHide() {
    this.close.emit();
  }

  onChangeChecked($event, value) {
    console.log('onChangeChecked', $event.target.value, value);
  }

  submitData() {
    this.addFavoriteLink();
  }

  /**
   * Подготавливает и направляет запрос на сервер для добавления ссылки в избранное
   */
  addFavoriteLink() {

    const object = this.favLinkForm.value;
    const params: Omit<FavoriteModel, 'id'> = {url: this.url, description: object.description.substr(0, 60), linkobjid: undefined, linktype: FavoriteType.URL};
    if (this.favorite.id && this.favorite.type && this.mode !== FavoriteType.URL) {
      params.linktype = this.favorite.type;
      params.linkobjid = parseInt(this.favorite.id, 10);
    }
    if (this.id) {
      this.favoritesApiService.save(this.id, params).subscribe(() => {
        this.hideEditDialog();
      });
    } else {
      this.favoritesApiService.create(params).subscribe(() => {
        this.hideEditDialog();
      });
    }
    return false;
  }

  onChangeMode(event) {
  }

    protected readonly undefined = undefined;
}
